<template>
  <div class="memberlist">
    <HpsfirProTable
      ref="tableRef"
      :paginations="{ pageSize: 10 }"
      page-layout="total, sizes, prev, pager, next"
      :columns="columns"
      :get-data="getData"
      :loading="loading"
      row-key="id"
      :operates="operates"
      :codition-init-values="conditionsInitValue"
      :hide-add="true"
      :hide-edit="true"
      :hide-delete="true"
    />
  </div>
</template>
<script lang="tsx" setup>
import {
  HpsfirProTable,
  HpsfirProTableColumn,
  HpsfirProTableData,
  HpsfirProTableFilter,
  HpsfirProTableGetDataFunction,
  useBaseAsync,
} from 'hpsfir-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ref } from 'vue';

const columns = ref<HpsfirProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof HpsfirProTable>>();

const conditionsInitValue = {
};

// 创建列定义
const createColumns = () => [
  {
    name: 'meta',
    label: '头像',
    type: 'string',
    width: 80,
    render(scope: any) {
      const avatar = scope.row.meta?.avatar;
      if (!avatar) {
        return (<el-avatar size={40} icon="User" />);
      }
      return (
        <el-avatar size={40} src={`${useApi().baseUrl}${avatar}`} />
      );
    },
  },
  {
    name: 'meta.name',
    label: '昵称',
    type: 'string',
    isCondition: true,
    width: 120,
    render: (scope: any) => scope.row.meta?.name || '-',
  },
  {
    name: 'meta.phone',
    label: '手机号',
    type: 'string',
    isCondition: true,
    width: 130,
    render: (scope: any) => scope.row.meta?.phone || '-',
  },
  {
    name: 'meta.points',
    label: '积分',
    type: 'string',
    width: 100,
    render: (scope: any) => scope.row.meta?.points || '0',
  },
  {
    name: 'meta.coins',
    label: 'D币',
    type: 'string',
    width: 100,
    render: (scope: any) => scope.row.meta?.coins || '0',
  },
  {
    name: 'meta.growthValue',
    label: '成长值',
    type: 'string',
    width: 100,
    render: (scope: any) => scope.row.meta?.growthValue || '0',
  },
  {
    name: 'createTime',
    label: '注册时间',
    type: 'string',
    width: 180,
  },
] as HpsfirProTableColumn[];


// 初始化
const init = useBaseAsync(() => {
  columns.value = createColumns();
});

const operates: any[] = [];

const loading = ref(false);

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;

    // 处理查询条件
    const conditions: Record<string, any> = { roleKeys: ['user'] };
    const metaConditions: string[] = [];

    Object.entries(filter.conditions).forEach(([key, val]) => {
      if (val === null || val === undefined || val === '') {
        return;
      }
      if (key === 'meta.phone') {
        metaConditions.push(`"phone": "%${val}%"`);
      } else if (key === 'meta.name') {
        metaConditions.push(`"name": "%${val}%"`);
      } else {
        conditions[key] = val;
      }
    });

    if (metaConditions.length > 0) {
      conditions.meta = metaConditions.join('%,%');
    }

    const res = await useApi().userApi.pageUsersuser({
      conditions,
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

Promise.all([init()]);
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
